import React from "react";
import PropTypes from "prop-types";

import { ContactUsWrapper, ContactBannerWrapper } from "./styles";

const ContactUsBanner = (props) => {
	const { header, description, backgroundStyle } = props;
	return (
		<ContactUsWrapper>
			<ContactBannerWrapper backgroundStyle={backgroundStyle}>
				<div className="hero-content-container banner-text-shadow">
					<h1>{header}</h1>
					<p>{description}</p>
				</div>
			</ContactBannerWrapper>
		</ContactUsWrapper>
	);
};

ContactUsBanner.propTypes = {
	header: PropTypes.string.isRequired,
	description: PropTypes.string,
	backgroundStyle: PropTypes.string.isRequired,
};

ContactUsBanner.defaultProps = {
	header: "",
	description: "",
	backgroundStyle: "",
};

export default ContactUsBanner;
